import { render, staticRenderFns } from "./images-upload.vue?vue&type=template&id=9d066918&scoped=true"
import script from "./images-upload.vue?vue&type=script&lang=ts"
export * from "./images-upload.vue?vue&type=script&lang=ts"
import style0 from "./images-upload.vue?vue&type=style&index=0&id=9d066918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d066918",
  null
  
)

export default component.exports